<template>
  <footer class="custom-footer">
    <div class="footer-bg"></div>
    <div class="footer-content">
      <div class="footer-logo-row">
        <img src="~@/../public/images/logo.png" class="footer-logo" alt="logo" />
      </div>
      <div class="footer-nav">
        <router-link to="/">首页</router-link>
        <span>|</span>
        <router-link to="/introduction">关于我们</router-link>
        <span>|</span>
        <router-link to="/projects">投资项目</router-link>
        <span>|</span>
        <router-link to="/news">新闻资讯</router-link>
        <span>|</span>
        <router-link to="/charity">慈善公益</router-link>
        <span>|</span>
        <router-link to="/contact">联系我们</router-link>
      </div>
      <div class="footer-info">
        <a href="https://beian.miit.gov.cn" target="_blank" rel="noopener noreferrer">粤ICP备2023048665号-1</a>
        <span style="margin: 0 8px;">|</span>
        <a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=44060502003607" target="_blank" rel="noopener noreferrer">粤公网安备44060502003607号</a>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'CustomFooter'
}
</script>

<style scoped>
.custom-footer {
  position: relative;
  z-index: 9999;
  width: 100vw;
  min-height: 260px;
  background: none;
  /* overflow: hidden; */
  margin-top: 100px;
  padding-top: 0;
}
.footer-bg {
  position: absolute;
  left: 0; top: 0; right: 0; bottom: 0;
  width: 100vw;
  height: 100%;
  background: url('~@/../public/images/footer.jpg') center center/cover no-repeat;
  z-index: 1;
}
.footer-content {
  position: relative;
  z-index: 2;
  top: -20px;
  width: 100vw;
  min-height: 260px;
  display: flex;
  flex-direction: column;
  align-items: center;
  /* justify-content: center; */
  /* background: rgba(255,255,255,0.72); */
  padding: 0px 0 24px 0;
}
.footer-logo-row {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 18px;
}
.footer-logo {
  height: 56px;
  width: auto;
  margin-right: 18px;
}
.footer-company {
  font-size: 32px;
  font-weight: 700;
  color: #000;
  letter-spacing: 2px;
}
.footer-nav {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 30px;
  font-size: 14px;
  color: #000;
  margin-bottom: 18px;
}
.footer-nav a {
    color: #000;
  text-decoration: none;
  transition: color 0.2s;
}
.footer-nav a:hover {
    color: #000;
}
.footer-nav span {
    color: #000;
  font-size: 18px;
}
.footer-info {
  color: #888;
  font-size: 13px;
  margin-top: 8px;
  text-align: center;
}
@media (max-width: 991px) {
  .footer-content {
    padding: 24px 0 16px 0;
    min-height: 180px;
  }
  .footer-logo {
    height: 38px;
    margin-right: 10px;
  }
  .footer-company {
    font-size: 22px;
  }
  .footer-nav {
    font-size: 15px;
    gap: 10px;
  }
  .footer-info {
    font-size: 13px;
  }
}
</style> 
